import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminTable from 'common/AdminTable';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit } from 'react-icons/fa';

const SubCategoryList = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const [subRes, catRes] = await Promise.all([
        getRequest('sub-categories'),
        getRequest('categories'),
      ]);
      setData(subRes?.data || []);
      setCategories(catRes?.data || []);
    } catch (err) {
      console.error('Failed to fetch sub categories:', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getCategoryName = (id) => {
    const cat = categories.find((c) => Number(c.id) === Number(id));
    return cat ? cat.name : id || '';
  };

  const handleRemove = async (id) => {
    if (!window.confirm('Are you sure you want to delete this sub category?')) return;
    try {
      await deleteRequest(`sub-categories/${id}`);
      fetchData();
    } catch (err) {
      console.error('Failed to delete sub category:', err);
    }
  };

  const tableHeaders = [
    { Header: 'Name', accessor: 'name' },
    {
      Header: 'Category',
      accessor: 'category_id',
      Cell: ({ row }) => getCategoryName(row.original.category_id)
    },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => navigate(`/sub-categories/update/${row.original.id}`)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleRemove(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Sub Category List</h4>
      </div>
      <div className="mx-4">
        {data?.length ? (
          <AdminTable tableHeaders={tableHeaders} tableData={data} />
        ) : (
          <p>No sub categories available.</p>
        )}
      </div>
    </div>
  );
};

export default SubCategoryList;
